import $ from 'jquery';

import * as Website from '../Config/Website.js';

const init = () => {
  const hash = window.location.hash;
  $('.js-tab').each(function() {
    const trigger = $(this).find('.js-trigger');
    trigger.on('click', function(e) {
      const target = $(this).data('tab');
      const tab = $(this).closest('.js-tab');
      $(this).addClass(Website.classList.act).siblings().removeClass(Website.classList.act);
      tab.find('.js-content.'+ Website.classList.actView).fadeOut(200, function() {
        $(this).attr('tabindex', '-1').removeClass(Website.classList.actView);
      });
      tab.find('.js-content'+target).fadeIn(200, function() {
        $(this).attr('tabindex', '0').addClass(Website.classList.actView);
        $(this)[0].focus({preventScroll: true});
      });
      return false;
    });

    $(this).find('.js-content').attr('tabindex', '-1').hide();
    if(hash && $(this).find('.js-content' + hash).length) {
      $(this).find('.js-trigger[data-tab="' + hash + '"]').click();
    } else {
      $(this).find('.js-trigger').eq(0).click();
    }
  });

}


export {
  init
}